import styled from '@emotion/styled';
import { Icon } from 'semantic-ui-react';

export const CheckIcon = ({
  value,
}: {
  value: boolean | string | number | object | undefined | null;
}) => {
  return (
    <S.Wrapper>
      {value ? (
        <Icon name="check square outline" size="large" />
      ) : (
        <Icon name="square outline" size="large" />
      )}
    </S.Wrapper>
  );
};

const S = {
  Wrapper: styled.div`
    text-align: center;
  `,
};
